export const IStorage = "IStorage";
